import Swiper from 'swiper'
import { Thumbs, Navigation, Pagination, EffectFade, Autoplay, A11y, Mousewheel, Scrollbar, FreeMode } from 'swiper/modules'

// import 'swiper/css'
// import 'swiper/css/navigation'
// import 'swiper/css/mousewheel'
// import 'swiper/css/pagination'
// import 'swiper/css/effect-fade'
// import 'swiper/css/effect-creative'

export const swiper = () => {
	homeBanner()
	affiliateLogos()
	caseStudiesPreview()
	solutionsCategories()
	resourcesPreview()
	itemisedDetail()
	timeline()
	teamSlider()
	imageSlider()
	articleImages()
	articleBlocks()
}

const homeBanner = () => {
	const el = document.querySelector('[data-swiper="home-banner-lead"]')

	if (!el) return

	let pagination = el.nextElementSibling

	new Swiper(el, {
		modules: [Autoplay, Pagination, EffectFade, A11y],
		effect: 'fade',
		loop: true,
		speed: 800,
		grabCursor: true,
		autoplay: {
			delay: 3500,
			disableOnInteraction: false
		},
		fadeEffect: {
			crossFade: true
		},
		pagination: {
			el: pagination,
			clickable: true
		}
	})
}

const affiliateLogos = () => {
	const el = document.querySelector('[data-swiper="affiliate-logos"]')

	if (!el) return

	let next = el.nextElementSibling,
		prev = el.nextElementSibling.nextElementSibling

	new Swiper(el, {
		modules: [Navigation, Pagination, A11y],
		speed: 800,
		slidesPerView: 2.25,
		centeredSlides: true,
		loop: true,
		navigation: {
			nextEl: next,
			prevEl: prev
		},
		breakpoints: {
			600: {
				slidesPerView: 3,
				centeredSlides: false
			},
			782: {
				slidesPerView: 4,
				centeredSlides: false
			},
			1200: {
				slidesPerView: 6,
				centeredSlides: false
			}
		}
	})
}

const caseStudiesPreview = () => {
	const el = document.querySelector('[data-swiper="case-studies-preview"]')

	if (!el) return

	let pagination = el.nextElementSibling

	new Swiper(el, {
		modules: [Pagination, EffectFade, A11y],
		effect: 'fade',
		loop: true,
		speed: 800,
		touchStartPreventDefault: false,
		pagination: {
			el: pagination,
			clickable: true
		},
		fadeEffect: {
			crossFade: true
		}
	})
}

const solutionsCategories = () => {
	const el = document.querySelector('[data-swiper="solutions-categories"]')

	if (!el) return

	let next = el.nextElementSibling,
		prev = el.nextElementSibling.nextElementSibling

	new Swiper(el, {
		modules: [Navigation, A11y],
		loop: false,
		speed: 800,
		slidesPerView: 1.25,
		spaceBetween: 24,
		navigation: {
			nextEl: next,
			prevEl: prev
		},
		breakpoints: {
			600: {
				slidesPerView: 2,
			},
			782: {
				slidesPerView: 3,
				spaceBetween: 0,
			},
			1280: {
				slidesPerView: 4,
			},
		},
	})
}

const resourcesPreview = () => {
	const el = document.querySelector('[data-swiper="resources-preview"]')

	if (!el) return

	let pagination = el.nextElementSibling

	new Swiper(el, {
		modules: [Pagination, A11y],
		slidesPerView: 1,
		spaceBetween: 24,
		loop: false,
		speed: 800,
		pagination: {
			el: pagination,
			clickable: true
		},
		breakpoints: {
			782: {
				slidesPerView: 3
			}
		}
	})
}

const itemisedDetail = () => {
	const el = document.querySelector('[data-swiper="itemised-detail"]')

	if (!el) return

	let next = el.nextElementSibling,
		prev = el.nextElementSibling.nextElementSibling,
		pagination = el.nextElementSibling.nextElementSibling.nextElementSibling

	new Swiper(el, {
		modules: [Navigation, Pagination, A11y],
		speed: 800,
		slidesPerView: 1.1,
		spaceBetween: 24,
		navigation: {
			nextEl: next,
			prevEl: prev
		},
		pagination: {
			el: pagination,
			clickable: true
		},
		breakpoints: {
			600: {
				slidesPerView: 1
			},
			782: {
				slidesPerView: 2
			}
		}
	})
}

const timeline = () => {
	const el = document.querySelector('[data-swiper="timeline"]')
	const thumbsEl = el?.nextElementSibling

	if (!el) return

	const thumbs = new Swiper(thumbsEl, {
		speed: 800,
		freeMode: true,
		spaceBetween: 24,
		slidesPerView: 'auto',
		watchSlidesProgress: true
	})

	new Swiper(el, {
		modules: [Thumbs, A11y],
		slidesPerView: 1.2,
		spaceBetween: 24,
		speed: 800,
		thumbs: {
			swiper: thumbs
		}
	})
}

const teamSlider = () => {
	const el = document.querySelector('[data-swiper="team"]')

	if (!el || window.innerWidth > 782) return

	new Swiper(el, {
		modules: [Navigation, A11y],
		slidesPerView: 1.1,
		centeredSlides: true,
		spaceBetween: 24,
		loop: true,
		speed: 800
	})
}

const imageSlider = () => {
	const el = document.querySelector('[data-swiper="images"]')
	const pagination = el?.querySelector('.swiper-pagination-bullets')

	if (!el) return

	new Swiper(el, {
		modules: [Navigation, Pagination, A11y],
		slidesPerView: 1,
		spaceBetween: 24,
		speed: 800,
		pagination: {
			el: pagination,
			clickable: true
		},
		breakpoints: {
			782: {
				slidesPerView: 2
			}
		}
	})
}

const articleImages = () => {
	const el = document.querySelector('[data-swiper="article"]')

	if (!el) return

	new Swiper(el, {
		modules: [Navigation, A11y],
		slidesPerView: 1.25,
		spaceBetween: 24,
		speed: 800,
		navigation: {
			nextEl: el.querySelector('.swiper-next'),
			prevEl: el.querySelector('.swiper-prev')
		},
		breakpoints: {
			782: {
				slidesPerView: 1.3
			}
		}
	})
}

const articleBlocks = () => {
	const el = document.querySelector('[data-swiper="article-blocks"]')

	if (!el) return

	new Swiper(el, {
		modules: [Navigation, A11y],
		slidesPerView: 1.25,
		spaceBetween: 24,
		speed: 800,
		navigation: {
			nextEl: el.querySelector('.swiper-next'),
			prevEl: el.querySelector('.swiper-prev')
		},
		breakpoints: {
			782: {
				slidesPerView: 2
			}
		}
	})
}

export default () => { }
